const { useI18n } = require('nordic/i18n');
const { Card } = require('@andes/card');
const { List, ListItem } = require('@andes/list');
const { Thumbnail } = require('@andes/thumbnail');

const translate = require('../../../translation');
const { generateIcon } = require('../../../utils/icons');

const LocalPickup = ({ handleShippingOptions, isMobile }) => {
  const { i18n } = useI18n();
  const translations = translate(i18n);

  return (
    <Card className="mt-16 mb-16" shadow={isMobile ? 'elevated' : undefined}>
      <List className="desktop-card" withDividers>
        <ListItem
          title={translations.PICK_UP_AT_SELLER_S_STORE}
          rightContentPosition="top"
          leftContent={
            <Thumbnail size="40" srLabel="icon_user">
              {generateIcon({ type: 'icon_official_store' })}
            </Thumbnail>
          }
          rightContent={
            <span className="modify-action">{translations.MODIFY}</span>
          }
          onClick={handleShippingOptions}
        />
      </List>
    </Card>
  );
};

module.exports = { LocalPickup };
